import { useEffect, useCallback } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { supabaseClient } from "src/lib/supabase/supabaseClient";
import { patientApi } from "src/api/services/patientApi";
import { useAppDispatch } from "src/app/hooks";
import Loading from "src/components/Loading/Loading";

function LogOut() {
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(async () => {
    try {
      await supabaseClient.auth.signOut();
      //these calls clear out the cached data from the rtk apis,
      dispatch(patientApi.util.resetApiState());
    } catch (err) {
      console.error("Logout failed:", err);
    }
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleLogout();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [handleLogout]);

  return (
    <Stack
      gap={4}
      justifyContent="center"
      alignItems={"center"}
      height={"100%"}
    >
      <Loading />
      <Typography textAlign="center" variant="h4">
        Securely logging you out.
      </Typography>
    </Stack>
  );
}

export default LogOut;
